import { useNuxtApp } from '#imports';

export default function useWTFApi() {
    const { $wtfApi } = useNuxtApp();

    if (!$wtfApi) {
        throw new Error('wtfApi api not provided from root app!');
    }
    return $wtfApi;
}
